import { render } from "./SegmentFilterItem.vue?vue&type=template&id=a86f1da4"
import script from "./SegmentFilterItem.vue?vue&type=script&lang=js"
export * from "./SegmentFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__